let shipmtReptFieldsArr = [
    {
        id: "shipmtId",
        label: "Shipment Id",
        minWidth: 170
    },
    {
        id: "custFName",
        label: "Customer name/ Consignor",
        minWidth: 170
    },
    {
        id: "custLName",
        label: "Customer Last Name",
        minWidth: 170
    },
    {
        id: "trkOpFName",
        label: "TrkOp First Name",
        minWidth: 170
    },
    {
        id: "trkOpLName",
        label: "TrkOp Last Name",
        minWidth: 170
    },
    {
        id: "cneeName",
        label: "Consignee Name",
        minWidth: 170
    },
    {
        id: "cnorGST",
        label: "Consignor GST",
        minWidth: 170
    },
    {
        id: "cneeGST",
        label: "Consignee GST",
        minWidth: 170
    },
    {
        id: "custReqId",
        label: "Customer Request Id",
        minWidth: 170
    },
    {
        id: "truckOpReqId",
        label: "Truck Operator Request Id",
        minWidth: 170
    },
    {
        id: "currStatus",
        label: "Status",
        minWidth: 170
    },
    {
        id: "tripStatus",
        label: "Trip Status",
        minWidth: 170
    },
    {
        id: "trkOpDataFilledBy",
        label: "TrkOp Data Filled By",
        minWidth: 170
    },
    {
        id: "custDataFilledBy",
        label: "Cust Data Filled BY",
        minWidth: 170
    },
    {
        id: "c_by",
        label: "Created By",
        minWidth: 170
    },
    {
        id: "c_at",
        label: "Created At",
        minWidth: 170
    },
    {
        id: "shipmtPicDate",
        label: "Pickup Date",
        minWidth: 170
    },
    {
        id: "shipmtDelDate",
        label: "Delivery Date",
        minWidth: 170
    },
    {
        id: "shipmtPicLoc",
        label: "Pickup Location",
        minWidth: 170
    },
    {
        id: "shipmtDelLoc",
        label: "Delivery Location",
        minWidth: 170
    },
    {
        id: "truckRegNo",
        label: "Truck No",
        minWidth: 170
    },
    {
        id: "matType",
        label: "Material Type",
        minWidth: 170
    },
    {
        id: "weight",
        label: "Weight",
        minWidth: 170
    },
    {
        id: "loadType",
        label: "Load Type",
        minWidth: 170
    },
    {
        id: "custMobile1",
        label: "Customer Mobile1",
        minWidth: 170
    },
    {
        id: "trkOpMobile1",
        label: "Truck Operator Mobile1",
        minWidth: 170
    },
    {
        id: "custPayType",
        label: "Cust Pay Type",
        minWidth: 170
    },
    {
        id: "cust_finalPrc",
        label: "Cust Pricing",
        minWidth: 170
    },
    {
        id: "pendingAmount",
        label: "Cust Pending Amt",
        minWidth: 170
    },
    {
        id: "quantity",
        label: "Pkgs",
        minWidth: 170
    },
    {
        id: "ewayA_no",
        label: "Eway bill no",
        minWidth: 170
    },
    {
        id: "lrNum",
        label: "Lr no (MLR)",
        minWidth: 170
    },
    {
        id: "drivName",
        label: "Driver Name",
        minWidth: 170
    },
    {
        id: "drivMobile1",
        label: "Driver Mobile",
        minWidth: 170
    },
    {
        id: "delInchName",
        label: "Incharge Name",
        minWidth: 170
    },
    {
        id: "delInchMobile1",
        label: "Incharge Mobile",
        minWidth: 170
    },
    {
        id: "trackingGPSLink",
        label: "Tracking Gps Link",
        minWidth: 170
    },
    //-----
    {
        id: "basePrc",
        label: "Base Price",
        minWidth: 170
    },
    {
        id: "aUnloadingCooli",
        label: "Unloading Coolie(+)",
        minWidth: 170
    },
    {
        id: "aLoadingCooli",
        label: "Loading Coolie(+)",
        minWidth: 170
    },
    {
        id: "aHalting",
        label: "Halting Charge(+)",
        minWidth: 170
    },
    {
        id: "aDemmurage",
        label: "Demurrage(+)",
        minWidth: 170
    },
    {
        id: "aOthers",
        label: "Others(+)",
        minWidth: 170
    },
    {
        id: "dTds",
        label: "TDS(-)",
        minWidth: 170
    },
    {
        id: "dCommission",
        label: "Commission(-)",
        minWidth: 170
    },
    {
        id: "dPenalty",
        label: "Penalty(-)",
        minWidth: 170
    },
    {
        id: "dClaim",
        label: "Claim(-)",
        minWidth: 170
    },
    {
        id: "dLoadingCooli",
        label: "Loading Coolie(-)",
        minWidth: 170
    },
    {
        id: "dUnloadingCooli",
        label: "Unloading Coolie(-)",
        minWidth: 170
    },
    {
        id: "dOthers",
        label: "Others(-)",
        minWidth: 170
    },

]

export default shipmtReptFieldsArr;